import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import Layout from "../../layouts/Layout";
import { rechercheroperateurs } from "../../services/parametres/operateur";
import { rechercherallprestataires } from "../../services/prestataires/prestatairesRequest";
import {
  rechercherallservices,
  rechercherserviceparprestataire,
} from "../../services/prestataires/service";
import {
  rechercherpaiement,
  statspaiementsprestataire,
  recherchernombrepaiement,
  recherchernombreetmontantpaiement,
  exporterlistepaiements,
  rechercherpaiementparoperateur,
} from "../../services/transactions/transactionsRequest";
import DateFilter from "../DateFilter";
import Paginate from "../pagination";
import moment from "moment";
import { Oval } from "react-loader-spinner";
import { rechercherprestatairestats } from "../../services/statistiques/StatistiquesRequest";
import { convertNumber } from "../../convertToMoneyFormat";
import { getDisplayMode } from "../../getDisplayMode";

function Transaction() {
  const { t } = useTranslation();
  let [listeTransactions, setlisteTransactions] = useState([]);
  let [listeTransactionsParOperateur, setlisteTransactionsParOperateur] =
    useState([]);
  let [listeSoldeReversement, setlisteSoldeReversement] = useState([]);
  let [listeMontantTransactions, setListeMontantTransactions] = useState([]);
  const [listeOperateur, setlisteOperateur] = useState([]);
  const [listeServices, setlisteServices] = useState([]);
  const [listePrestataire, setlistePrestataire] = useState([]);
  let [filterParametres, setfilterParametres] = useState({
    codeOperateur: "",
    dateDebut: "",
    dateFin: "",
    param: "",
    prestataire_id: "",
    service_id: "",
    valide: "",
    reverse: "",
  });
  let [filterParametresOperateur, setfilterParametresOperateur] = useState({
    dateDebut: "",
    dateFin: "",
    prestataire_id: "",
    service_id: "",
  });
  const [montantAreverser, setmontantAreverser] = useState("");

  const [totalElement, settotalElement] = useState(0);
  const [totalElementSolde, settotalElementSolde] = useState(0);
  const [totalElementByPage, setTotalElementByPage] = useState(0);
  const [totalElementByPageSolde, setTotalElementByPageSolde] = useState(0);
  const [totalElement2, settotalElement2] = useState(0);
  const [totalElementByPage2, setTotalElementByPage2] = useState(0);
  const [nombreTransactionTotal, setNombreTransactionTotal] = useState(0);
  const [montantTransactionTotal, setMontantTransactionTotal] = useState(0);
  const [pageActive, setPageActive] = useState(1);
  const [pageActiveSolde, setPageActiveSolde] = useState(1);
  const [loading, setloading] = useState(false);
  const [loadingSolde, setloadingSolde] = useState(false);
  const [loadingDownload, setloadingDownload] = useState(false);
  const [infoStats, setinfoStats] = useState({});
  const [currentComponent, setCurrentComponent] = useState("TRANSACTION");
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);

  const listeStatut = [
    { id: 0, value: 2, label: t('transactions.status.failure') },
    { id: 1, value: 1, label: t('transactions.status.success') },
  ];

  function tansformerObjetEnTableau(objet) {
    let keyTable = Object.keys(objet);
    let valueTable = Object.values(objet);
    let tableau = [];
    for (let i = 0; i < keyTable.length; i++) {
      let objet = { code: keyTable[i], name: valueTable[i] };
      tableau.push(valueTable[i]);
    }
    return tableau;
  }

  const handlePageChange = (pageNumber) => {
    setPageActive(pageNumber);
    afficherTransactions(pageNumber);
  };

  const handlePageChangeSolde = (pageNumber) => {
    setPageActiveSolde(pageNumber);
    afficherSoldeReversement(pageNumber);
  };

  const handlePageChange2 = (pageNumber) => {
    setPageActive(pageNumber);
    afficherNombreTransactions(pageNumber);
  };

  //  Récuperation des transactions
  const afficherTransactions = (currentPage, typeTransaction = "") => {
    setloading(true);
    rechercherpaiement(
      {
        ...filterParametres,
        reverse: typeTransaction ? typeTransaction : filterParametres.reverse,
      },
      currentPage
    )
      .then((res) => {
        setloading(false);
        setlisteTransactions([]);
        listeTransactions = res.data.donnee.data;
        setlisteTransactions(listeTransactions);
        settotalElement(res.data.donnee.total);
        setTotalElementByPage(res.data.donnee.per_page);
      })
      .catch((error) => {
        setloading(false);
      });
  };

  const afficherTransactionsParOperateur = () => {
    setloading(true);
    console.log("voyage ===> 999");
    rechercherpaiementparoperateur(filterParametresOperateur)
      .then((res) => {
        setloading(false);
        setlisteTransactionsParOperateur([]);
        listeTransactionsParOperateur =
          res.data.donnee && res.data.donnee.operateurs
            ? res.data.donnee.operateurs
            : [];
        setlisteTransactionsParOperateur(listeTransactionsParOperateur);
      })
      .catch((error) => {
        setloading(false);
      });
  };

  //  Récuperation des soldes reversement
  const afficherSoldeReversement = (currentPage) => {
    setloadingSolde(true);
    setlisteSoldeReversement([]);
    rechercherpaiement(filterParametres, currentPage)
      .then((res) => {
        setloadingSolde(false);
        setlisteSoldeReversement(res.data.donnee.data);
        settotalElementSolde(res.data.donnee.total);
        setTotalElementByPageSolde(res.data.donnee.per_page);
      })
      .catch((error) => {
        setloadingSolde(false);
      });
  };

  //  Récupère les nombres transactions
  const afficherNombreTransactions = (currentPage) => {
    setloading(true);
    recherchernombrepaiement(filterParametres, currentPage)
      .then((res) => {
        setloading(false);
        if (Array.isArray(res.data["data"])) {
          setListeMontantTransactions(
            res.data && res.data.data ? res.data.data : []
          );
        } else {
          setListeMontantTransactions(
            tansformerObjetEnTableau(res.data["data"])
          );
        }
        settotalElement2(res.data && res.data.total ? res.data.total : 0);
        setTotalElementByPage2(
          res.data && res.data.per_page ? res.data.per_page : 0
        );
      })
      .catch((error) => {
        setloading(false);
      });
  };

  // Nombre et Montant total des transaction
  const afficherNombreEtMontantTotalTransactions = (currentPage) => {
    setloading(true);
    recherchernombreetmontantpaiement(filterParametres, currentPage)
      .then((res) => {
        setloading(false);
        setNombreTransactionTotal(
          res.data && res.data.donnee ? res.data.donnee.nombreTotal : "0"
        );
        setMontantTransactionTotal(
          res.data && res.data.donnee ? res.data.donnee.montantTotal : "0"
        );
      })
      .catch((error) => {
        setloading(false);
      });
  };

  const afficherOperateur = () => {
    rechercheroperateurs()
      .then((res) => {
        setlisteOperateur(res.data.donnee);
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };

  const afficherService = (id = 0) => {
    rechercherserviceparprestataire(id).then((res) => {
      setlisteServices(res.data.donnee);
    });
  };

  const displayAllservice = () => {
    rechercherallservices().then((res) => {
      setlisteServices(res.data.donnee);
    });
  };

  const afficherPrestataire = () => {
    rechercherallprestataires().then((res) => {
      setlistePrestataire(res.data.donnee);
    });
  };

  //Filtrer par prestataire
  const handleRecupereIdPrestataireAndFilter = (e) => {
    //setPageActive(1);
    e.target.value === ""
      ? displayAllservice()
      : afficherService(e.target.value);
    filterParametres.prestataire_id = e.target.value;
    filterParametres.service_id = "";
    setfilterParametres(filterParametres);
    filterParametresOperateur.prestataire_id = e.target.value;
    filterParametresOperateur.service_id = "";
    setfilterParametresOperateur(filterParametresOperateur);
    recuperermontantareverser();
    afficherTransactions(1);
    afficherTransactionsParOperateur();
    afficherStats();
  };

  //Filtrer par opérateur
  const filterOnOperator = (e) => {
    filterParametres.codeOperateur = e.target.value;
    setfilterParametres(filterParametres);

    if (currentComponent === "TRANSACTION") {
      afficherStats();
      recuperermontantareverser();
    }

    if (
      currentComponent !== "AUTRES" &&
      currentComponent !== "PAIEMENT_OPERATEUR"
    ) {
      afficherTransactions(
        1,
        currentComponent === "PAIEMENTS_EFFECTUES"
          ? "0"
          : currentComponent === "TRANSFERT"
            ? "1"
            : ""
      );
    }

    if (currentComponent === "AUTRES") {
      afficherNombreTransactions(1);
      afficherNombreEtMontantTotalTransactions(1);
    }

    if (currentComponent === "PAIEMENT_OPERATEUR") {
      afficherTransactionsParOperateur();
    }
  };

  //Filtrer par Service
  const filterOnService = (e) => {
    filterParametres.service_id = e.target.value;
    setfilterParametres(filterParametres);

    filterParametresOperateur.service_id = e.target.value;
    setfilterParametresOperateur(filterParametresOperateur);

    if (currentComponent === "TRANSACTION") {
      afficherStats();
      recuperermontantareverser();
    }

    if (
      currentComponent !== "AUTRES" &&
      currentComponent !== "PAIEMENT_OPERATEUR"
    ) {
      afficherTransactions(
        1,
        currentComponent === "PAIEMENTS_EFFECTUES"
          ? "0"
          : currentComponent === "TRANSFERT"
            ? "1"
            : ""
      );
    }

    if (currentComponent === "AUTRES") {
      afficherNombreTransactions(1);
      afficherNombreEtMontantTotalTransactions(1);
    }

    if (currentComponent === "PAIEMENT_OPERATEUR") {
      afficherTransactionsParOperateur();
    }
  };

  //Filtrer par statuts
  const filterOnStatut = (e) => {
    filterParametres.valide = e.target.value;
    setfilterParametres(filterParametres);
    afficherTransactions(1);
    recuperermontantareverser();
    afficherStats();
  };

  //Filtrer par type transaction
  const filterOnTypeTransaction = (e) => {
    filterParametres.reverse = e.target.value;
    setfilterParametres(filterParametres);
    afficherTransactions(1);
    recuperermontantareverser();
    afficherStats();
  };

  // 0 echech 1 succes valide

  //Zone de recherche
  const handleSearchTransaction = (e) => {
    filterParametres.param = e.target.value;
    setfilterParametres(filterParametres);
    afficherTransactions(1);
    afficherStats();

    if (
      currentComponent !== "AUTRES" &&
      currentComponent !== "PAIEMENT_OPERATEUR"
    ) {
      afficherTransactions(
        1,
        currentComponent === "PAIEMENTS_EFFECTUES"
          ? "0"
          : currentComponent === "TRANSFERT"
            ? "1"
            : ""
      );
      afficherStats();
    }
  };

  //Recherche sur la date
  const filterOnDate = (dateDebut, dateFin) => {
    filterParametres.dateDebut =
      dateDebut !== null && dateDebut !== ""
        ? moment(dateDebut).format("yyyy-MM-DD")
        : "";
    filterParametres.dateFin =
      dateFin !== null && dateFin !== ""
        ? moment(dateFin).format("yyyy-MM-DD")
        : "";
    setfilterParametres(filterParametres);

    filterParametresOperateur.dateDebut =
      dateDebut !== null && dateDebut !== ""
        ? moment(dateDebut).format("yyyy-MM-DD")
        : "";
    filterParametresOperateur.dateFin =
      dateFin !== null && dateFin !== ""
        ? moment(dateFin).format("yyyy-MM-DD")
        : "";
    setfilterParametresOperateur(filterParametresOperateur);

    if (
      currentComponent !== "AUTRES" &&
      currentComponent !== "PAIEMENT_OPERATEUR"
    ) {
      afficherTransactions(
        1,
        currentComponent === "PAIEMENTS_EFFECTUES"
          ? "0"
          : currentComponent === "TRANSFERT"
            ? "1"
            : ""
      );
      afficherStats();
    }

    if (currentComponent === "AUTRES") {
      afficherNombreTransactions(1);
      afficherNombreEtMontantTotalTransactions(1);
    }

    if (currentComponent === "PAIEMENT_OPERATEUR") {
      afficherTransactionsParOperateur();
    }
  };

  const afficherStats = () => {
    statspaiementsprestataire(filterParametres).then((res) => {
      setinfoStats(res.data.donnee);
    });
  };

  //afficher montant à reverser
  const recuperermontantareverser = () => {
    let infoprestataire = {
      prestataire_id: filterParametres.prestataire_id,
      service_id: filterParametres.service_id,
      codeOperateur: filterParametres.codeOperateur,
      dateDebut: filterParametres.dateDebut,
      dateFin: filterParametres.dateFin,
    };
    rechercherprestatairestats(infoprestataire)
      .then((reponse) => {
        setmontantAreverser(reponse.data.donnee);
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };

  const changeViewComponent = (view) => {
    filterParametres.dateDebut = "";
    filterParametres.dateFin = "";
    setfilterParametres({
      codeOperateur: "",
      dateDebut: "",
      dateFin: "",
      param: "",
      prestataire_id: "",
      service_id: "",
      valide: "",
      reverse: "",
    });
    setPageActive(1);
    setCurrentComponent(view);

    if (view !== "AUTRES" && view !== "PAIEMENT_OPERATEUR") {
      afficherTransactions(
        1,
        view === "PAIEMENTS_EFFECTUES" ? "0" : view === "TRANSFERT" ? "1" : ""
      );
    }

    if (view === "AUTRES") {
      afficherNombreTransactions(1);
      afficherNombreEtMontantTotalTransactions(1);
    }

    if (view === "PAIEMENT_OPERATEUR") {
      afficherTransactionsParOperateur();
    }
  };

  const exporterTransactions = () => {
    setloadingDownload(true);
    exporterlistepaiements(filterParametres)
      .then((response) => {
        setloadingDownload(false);

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        console.log("url pos", url);
        link.setAttribute("download", `transactions.csv`); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        setloadingDownload(false);
      });
  };

  useEffect(() => {
    afficherNombreTransactions(pageActive);
    afficherNombreEtMontantTotalTransactions(pageActive);
    afficherOperateur();
    afficherPrestataire();
    displayAllservice();
    recuperermontantareverser();
    afficherStats();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("role") !== "ROLE_ADMIN") {
      afficherTransactions(pageActive, "0");
      setCurrentComponent("PAIEMENTS_EFFECTUES");
      setfilterParametres({
        codeOperateur: "",
        dateDebut: "",
        dateFin: "",
        param: "",
        prestataire_id: "",
        service_id: "",
        valide: "",
        reverse: "0",
      });
    } else {
      afficherTransactions(pageActive);
    }
  }, []);

  const rowListeTransaction = listeTransactions.map((item, index) => (
    <tr key={index}>
      <td>{item.service !== null && item.service.designation} </td>
      <td>{item.reference}</td>
      <td>
        {item.operateurMobileMoney_id !== null && item.operateurMobileMoney_id}
      </td>
      <td>{item.numero}</td>
      <td>
        {" "}
        {item.reverse == 1
          ? "-" + convertNumber(item.valeur)
          : convertNumber(item.valeur)}{" "}
        FCFA
      </td>
      <td> {item.commission} </td>
      <td>
        {item.datePaiement !== undefined &&
          moment(item.datePaiement).format("DD-MM-yyyy H:m")}
      </td>
      <td
        className={item.valide ? "text-success fw-bold" : "text-danger fw-bold"}
      >
        {item.valide ? t('transactions.status.success') : t('transactions.status.failure')}
        {localStorage.getItem("role") === "ROLE_ADMIN" && !item.valide && (
          <button className="btn-sm btn">
            <i className="fas fa-redo"></i>
          </button>
        )}
      </td>
    </tr>
  ));

  const rowListePaiementParOperateur = listeTransactionsParOperateur.map(
    (item, index) => (
      <tr key={index}>
        <td>{item.operateur_nom !== null && item.operateur_nom}</td>
        <td>{item.nombre_transactions}</td>
        <td>{convertNumber(item.montant_total)} FCFA</td>
        <td> {convertNumber(item.commission_totale)} </td>
        <td> {convertNumber(item.montant_reverse)} </td>
      </tr>
    )
  );

  const rowListeReversementSolde = infoStats ? (
    <tr>
      <td>
        {infoStats && infoStats.montantPaiement
          ? convertNumber(infoStats.montantPaiement)
          : "0"}{" "}
        FCFA
      </td>
      <td>
        {infoStats && infoStats.montantReversementAutomatiqueGlobal
          ? convertNumber(infoStats.montantReversementAutomatiqueGlobal)
          : "0"}{" "}
        FCFA
      </td>
      <td>
        {infoStats && infoStats.montantReversementManuelGlobal
          ? convertNumber(infoStats.montantReversementManuelGlobal)
          : "0"}{" "}
        FCFA
      </td>
      <td>
        {infoStats && infoStats.commissionGlobal
          ? convertNumber(infoStats.commissionGlobal)
          : "0"}{" "}
        FCFA
      </td>
      <td>{montantAreverser ? convertNumber(montantAreverser) : "0"} FCFA</td>
    </tr>
  ) : (
    <tr>
      <td colspan="3">
        <p
          className="text-center"
          style={{ paddingTop: "30px", paddingBottom: "30px" }}
        >
          {t('transactions.summary.noReversal')}
        </p>
      </td>
    </tr>
  );

  const rowListeMontantTransaction =
    listeMontantTransactions &&
    listeMontantTransactions.length > 0 &&
    listeMontantTransactions.map((item, index) => (
      <tr key={index}>
        <td>{item.service !== null && item.service.designation} </td>
        <td>{item.nombre}</td>
        <td>{item.montant} FCFA</td>
        <td>{item.montantPaiement} FCFA</td>
        <td>{item.montantReversement} FCFA</td>
        <td>{item.commission} FCFA</td>
      </tr>
    ));

  const optionListeOperateur =
    listeOperateur &&
    listeOperateur.length > 0 &&
    listeOperateur.map((item, index) => (
      <option key={index} value={item.id}>
        {item.designation + " | " + item.id}
      </option>
    ));

  const optionListeService = listeServices.map((item) => (
    <option key={item.id} value={item.id}>
      {item.designation}
    </option>
  ));

  const optionPrestataire =
    listePrestataire &&
    listePrestataire.length > 0 &&
    listePrestataire.map((item) => (
      <option key={item.id} value={item.id}>
        {item.nom}
      </option>
    ));

  const optionStatut =
    listeStatut &&
    listeStatut.length > 0 &&
    listeStatut.map((item) => (
      <option key={item.id} value={item.value}>
        {item.label}
      </option>
    ));

  return (
    <Layout>
      <div style={{ marginTop: "30px" }}>
        <div
          style={{
            width: "fit-content",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "end",
            marginBottom: 30,
            backgroundColor: "transparent",
            gap: "8px",
          }}
        >
          {localStorage.getItem("role") === "ROLE_ADMIN" && (
            <div
              className="tab-button btn"
              style={{
                backgroundColor:
                  currentComponent === "TRANSACTION" ? "#f9ba14" : "#e8e8e8",
              }}
              onClick={() => changeViewComponent("TRANSACTION")}
            >
              <p
                style={{
                  fontSize: 14,
                  cursor: "pointer",
                  color: currentComponent === "TRANSACTION" ? "#000" : "#999",
                  margin: 0,
                  fontWeight: "bold",
                }}
              >
                {t('transactions.tabs.transactions')}
              </p>
            </div>
          )}
          {localStorage.getItem("role") === "ROLE_ADMIN" && (
            <div
              className="tab-button btn"
              style={{
                backgroundColor:
                  currentComponent === "AUTRES" ? "#f9ba14" : "#e8e8e8",
              }}
              onClick={() => changeViewComponent("AUTRES")}
            >
              <p
                style={{
                  fontSize: 14,
                  cursor: "pointer",
                  color: currentComponent === "AUTRES" ? "#000" : "#999",
                  margin: 0,
                  fontWeight: "bold",
                }}
              >
                {t('transactions.tabs.amountByService')}
              </p>
            </div>
          )}
          {localStorage.getItem("role") !== "ROLE_ADMIN" && (
            <div
              className="tab-button btn"
              style={{
                backgroundColor:
                  currentComponent === "PAIEMENTS_EFFECTUES"
                    ? "#f9ba14"
                    : "#e8e8e8",
              }}
              onClick={() => changeViewComponent("PAIEMENTS_EFFECTUES")}
            >
              <p
                style={{
                  fontSize: 14,
                  cursor: "pointer",
                  color:
                    currentComponent === "PAIEMENTS_EFFECTUES"
                      ? "#000"
                      : "#999",
                  margin: 0,
                  fontWeight: "bold",
                }}
              >
                {t('transactions.tabs.paymentsCompleted')}
              </p>
            </div>
          )}
          {localStorage.getItem("role") !== "ROLE_ADMIN" && (
            <div
              className="tab-button btn"
              style={{
                backgroundColor:
                  currentComponent === "TRANSFERT" ? "#f9ba14" : "#e8e8e8",
              }}
              onClick={() => changeViewComponent("TRANSFERT")}
            >
              <p
                style={{
                  fontSize: 14,
                  cursor: "pointer",
                  color: currentComponent === "TRANSFERT" ? "#000" : "#999",
                  margin: 0,
                  fontWeight: "bold",
                }}
              >
                {t('transactions.tabs.transfers')}
              </p>
            </div>
          )}
          <div
            className="tab-button btn"
            style={{
              backgroundColor:
                currentComponent === "PAIEMENT_OPERATEUR"
                  ? "#f9ba14"
                  : "#e8e8e8",
            }}
            onClick={() => changeViewComponent("PAIEMENT_OPERATEUR")}
          >
            <p
              style={{
                fontSize: 14,
                cursor: "pointer",
                color:
                  currentComponent === "PAIEMENT_OPERATEUR" ? "#000" : "#999",
                margin: 0,
                fontWeight: "bold",
              }}
            >
              {t('transactions.tabs.paymentsByOperator')}
            </p>
          </div>
        </div>

        {/* TRANSACTION */}
        {currentComponent === "TRANSACTION" && (
          <div>
            {/* SECTION DES CARDS PAIEMENTS ADMIN */}
            <div className="row mb-3 gap-2">
              {localStorage.getItem("role") === "ROLE_ADMIN" && (
                <div
                  style={{
                    backgroundColor: "#fffbeb",
                    borderRadius: "8px",
                    padding: "14px",
                    border: "1px solid #fef3c7",
                    minWidth: "280px",
                  }}
                  className="col"
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "100px",
                        backgroundColor: "#fef3c7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                      }}
                    >
                      <i
                        className="fas fa-calendar-day"
                        style={{ color: "#f57c00", fontSize: "14px" }}
                      ></i>
                    </div>
                    <div>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {t('transactions.cards.todayPayment')}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.number')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#333",
                        }}
                      >
                        {infoStats.nbrePaiementJour === undefined
                          ? 0
                          : infoStats.nbrePaiementJour}
                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.amount')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#f57c00",
                        }}
                      >
                        {infoStats.montantPaiementJour === undefined
                          ? 0
                          : convertNumber(infoStats.montantPaiementJour)}{" "}
                        FCFA
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {localStorage.getItem("role") === "ROLE_ADMIN" && (
                <div
                  style={{
                    backgroundColor: "#ecfdf5",
                    borderRadius: "8px",
                    padding: "14px",
                    border: "1px solid #d1fae5",
                    minWidth: "280px",
                  }}
                  className="col"
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "100px",
                        backgroundColor: "#e8f5e8",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                      }}
                    >
                      <i
                        className="fas fa-calendar-alt"
                        style={{ color: "#4caf50", fontSize: "14px" }}
                      ></i>
                    </div>
                    <div>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {t('transactions.cards.monthPayment')}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.number')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#333",
                        }}
                      >
                        {infoStats.nbrePaiementMois === undefined
                          ? 0
                          : infoStats.nbrePaiementMois}
                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.amount')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#4caf50",
                        }}
                      >
                        {infoStats.montantPaiementMois === undefined
                          ? 0
                          : convertNumber(infoStats.montantPaiementMois)}{" "}
                        FCFA
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {localStorage.getItem("role") === "ROLE_ADMIN" && (
                <div
                  style={{
                    backgroundColor: "#f0f9ff",
                    borderRadius: "8px",
                    padding: "14px",
                    border: "1px solid #e0f2fe",
                    minWidth: "280px",
                  }}
                  className="col"
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "100px",
                        backgroundColor: "#e3f2fd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                      }}
                    >
                      <i
                        className="fas fa-globe"
                        style={{ color: "#2196f3", fontSize: "14px" }}
                      ></i>
                    </div>
                    <div>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {t('transactions.cards.globalPayment')}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.number')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#333",
                        }}
                      >
                        {infoStats.nbrePaiement === undefined
                          ? 0
                          : infoStats.nbrePaiement}
                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.amount')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#2196f3",
                        }}
                      >
                        {infoStats.montantPaiement === undefined
                          ? 0
                          : convertNumber(infoStats.montantPaiement)}{" "}
                        FCFA
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {localStorage.getItem("role") === "ROLE_ADMIN" && (
                <div
                  style={{
                    backgroundColor: "#faf5ff",
                    borderRadius: "8px",
                    padding: "14px",
                    border: "1px solid #fae8ff",
                    minWidth: "280px",
                  }}
                  className="col"
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "100px",
                        backgroundColor: "#f3e5f5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                      }}
                    >
                      <i
                        className="fas fa-wallet"
                        style={{ color: "#9c27b0", fontSize: "14px" }}
                      ></i>
                    </div>
                    <div>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {localStorage.getItem("role") === "ROLE_ADMIN"
                          ? t('transactions.cards.amountToReverse')
                          : t('transactions.cards.balance')}
                      </h5>
                    </div>
                  </div>
                  <div className="mt-2">
                    <p
                      style={{
                        margin: 0,
                        fontSize: "12px",
                        color: "#666",
                        fontWeight: "500",
                      }}
                    >
                      {t('transactions.cards.amount')}
                    </p>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#9c27b0",
                      }}
                    >
                      {montantAreverser !== undefined &&
                        convertNumber(montantAreverser)}{" "}
                      FCFA
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* SECTION DES CARDS COMMISSION ADMIN */}
            <div className="row mb-3 gap-2">
              {localStorage.getItem("role") === "ROLE_ADMIN" && (
                <div
                  style={{
                    backgroundColor: "#fff1f2",
                    borderRadius: "8px",
                    padding: "14px",
                    border: "1px solid #fecdd3",
                    minWidth: "280px",
                  }}
                  className="col"
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "100px",
                        backgroundColor: "#fef3c7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                      }}
                    >
                      <i
                        className="fas fa-calendar-day"
                        style={{ color: "#f57c00", fontSize: "14px" }}
                      ></i>
                    </div>
                    <div>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {t('transactions.cards.todayCommission')}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.amount')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#f43f5e",
                        }}
                      >
                        {infoStats.commissionJour === undefined
                          ? 0
                          : convertNumber(infoStats.commissionJour)}{" "}
                        FCFA
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {localStorage.getItem("role") === "ROLE_ADMIN" && (
                <div
                  style={{
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    padding: "14px",
                    border: "1px solid #e2e8f0",
                    minWidth: "280px",
                  }}
                  className="col"
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "100px",
                        backgroundColor: "#e8f5e8",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                      }}
                    >
                      <i
                        className="fas fa-calendar-alt"
                        style={{ color: "#4caf50", fontSize: "14px" }}
                      ></i>
                    </div>
                    <div>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {t('transactions.cards.monthCommission')}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.amount')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#64748b",
                        }}
                      >
                        {infoStats.commissionMois === undefined
                          ? 0
                          : convertNumber(infoStats.commissionMois)}{" "}
                        FCFA
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {localStorage.getItem("role") === "ROLE_ADMIN" && (
                <div
                  style={{
                    backgroundColor: "#ecfeff",
                    borderRadius: "8px",
                    padding: "14px",
                    border: "1px solid #a5f3fc",
                    minWidth: "280px",
                  }}
                  className="col"
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "100px",
                        backgroundColor: "#e3f2fd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                      }}
                    >
                      <i
                        className="fas fa-globe"
                        style={{ color: "#2196f3", fontSize: "14px" }}
                      ></i>
                    </div>
                    <div>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {t('transactions.cards.globalCommission')}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.amount')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#06b6d4",
                        }}
                      >
                        {infoStats.commissionGlobal === undefined
                          ? 0
                          : convertNumber(infoStats.commissionGlobal)}{" "}
                        FCFA
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* SECTION DES CARDS REVERSEMENT ADMIN */}
            <div className="row mb-3 gap-2">
              {localStorage.getItem("role") === "ROLE_ADMIN" && (
                <div
                  style={{
                    backgroundColor: "#fffbeb",
                    borderRadius: "8px",
                    padding: "14px",
                    border: "1px solid #fef3c7",
                    minWidth: "280px",
                  }}
                  className="col"
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "100px",
                        backgroundColor: "#fef3c7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                      }}
                    >
                      <i
                        className="fas fa-calendar-day"
                        style={{ color: "#f57c00", fontSize: "14px" }}
                      ></i>
                    </div>
                    <div>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {t('transactions.cards.todayReversal')}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.manual')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#333",
                        }}
                      >
                        {!infoStats.montantReversementManuelDuJour
                          ? 0
                          : convertNumber(
                            infoStats.montantReversementManuelDuJour
                          )}{" "}
                        FCFA
                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.automatic')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#f57c00",
                        }}
                      >
                        {!infoStats.montantReversementAutomatiqueDuJour
                          ? 0
                          : convertNumber(
                            infoStats.montantReversementAutomatiqueDuJour
                          )}{" "}
                        FCFA
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {localStorage.getItem("role") === "ROLE_ADMIN" && (
                <div
                  style={{
                    backgroundColor: "#ecfdf5",
                    borderRadius: "8px",
                    padding: "14px",
                    border: "1px solid #d1fae5",
                    minWidth: "280px",
                  }}
                  className="col"
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "100px",
                        backgroundColor: "#e8f5e8",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                      }}
                    >
                      <i
                        className="fas fa-calendar-alt"
                        style={{ color: "#4caf50", fontSize: "14px" }}
                      ></i>
                    </div>
                    <div>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {t('transactions.cards.monthReversal')}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.manual')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#333",
                        }}
                      >
                        {!infoStats.montantReversementManuelDuMois
                          ? 0
                          : convertNumber(
                            infoStats.montantReversementManuelDuMois
                          )}{" "}
                        FCFA
                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.automatic')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#4caf50",
                        }}
                      >
                        {!infoStats.montantReversementAutomatiqueDuMois
                          ? 0
                          : convertNumber(
                            infoStats.montantReversementAutomatiqueDuMois
                          )}{" "}
                        FCFA
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {localStorage.getItem("role") === "ROLE_ADMIN" && (
                <div
                  style={{
                    backgroundColor: "#f0f9ff",
                    borderRadius: "8px",
                    padding: "14px",
                    border: "1px solid #e0f2fe",
                    minWidth: "280px",
                  }}
                  className="col"
                >
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "38px",
                        height: "38px",
                        borderRadius: "100px",
                        backgroundColor: "#e3f2fd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                      }}
                    >
                      <i
                        className="fas fa-globe"
                        style={{ color: "#2196f3", fontSize: "14px" }}
                      ></i>
                    </div>
                    <div>
                      <h5
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {t('transactions.cards.globalReversal')}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.manual')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#333",
                        }}
                      >
                        {!infoStats.montantReversementManuelGlobal
                          ? 0
                          : convertNumber(
                            infoStats.montantReversementManuelGlobal
                          )}{" "}
                        FCFA
                      </p>
                    </div>
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "12px",
                          color: "#666",
                          fontWeight: "500",
                        }}
                      >
                        {t('transactions.cards.automatic')}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#4caf50",
                        }}
                      >
                        {!infoStats.montantReversementAutomatiqueGlobal
                          ? 0
                          : convertNumber(
                            infoStats.montantReversementAutomatiqueGlobal
                          )}{" "}
                        FCFA
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="">
              {/* Header avec boutons Sort et Filter */}
              <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                <div>
                  <h4
                    style={{
                      margin: 0,
                      fontSize: "18px",
                      fontWeight: "800",
                      color: "#000",
                    }}
                  >
                    {t('transactions.history.transactions')}
                  </h4>
                </div>

                <div className="d-flex gap-3" style={{ position: "relative" }}>
                  <button
                    onClick={() => exporterTransactions()}
                    style={{
                      backgroundColor: "#f9ba14",
                      borderRadius: "8px",
                      border: "none",
                      padding: "8px 16px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "black",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {loadingDownload ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t('transactions.actions.loading')}
                      </>
                    ) : (
                      <>
                        <i
                          className="fas fa-file-export"
                          style={{ fontSize: "12px" }}
                        ></i>
                        {t('transactions.actions.export')}
                      </>
                    )}
                  </button>
                  <button
                    onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                    style={{
                      backgroundColor: "black",
                      borderRadius: "8px",
                      border: "none",
                      padding: "8px 16px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i
                      className="fas fa-filter"
                      style={{ fontSize: "12px" }}
                    ></i>
                    Filter
                  </button>

                  {/* Dropdown de filtres */}
                  {showFilterDropdown && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: "0",
                        marginTop: "8px",
                        backgroundColor: "white",
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        padding: "14px",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        minWidth: "350px",
                        maxHeight: "600px",
                        // overflowY: "auto",
                      }}
                    >
                      {/* Recherche par mot-clé */}
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.search')}
                          </h6>
                        </div>

                        <div style={{ position: "relative" }}>
                          <input
                            onChange={(e) => handleSearchTransaction(e)}
                            type="text"
                            placeholder="Search..."
                            style={{
                              width: "100%",
                              padding: "12px 8px 12px 45px",
                              border: "1px solid #d1d5db",
                              borderRadius: "6px",
                              fontSize: "14px",
                              backgroundColor: "#fafafa",
                            }}
                          />
                          <i
                            className="fas fa-search"
                            style={{
                              position: "absolute",
                              left: "16px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#9ca3af",
                              fontSize: "14px",
                            }}
                          ></i>
                        </div>
                      </div>

                      {/* Date range */}
                      <div style={{ marginBottom: "8px" }}>
                        <h6
                          className="mb-1"
                          style={{
                            fontSize: "14px",
                            fontWeight: "800",
                            color: "#374151",
                            margin: 0,
                          }}
                        >
                          {t('transactions.filters.period')}
                        </h6>
                        <DateFilter filterElement={filterOnDate} />
                      </div>

                      {/* typetransaction */}
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.transactionType')}
                          </h6>
                        </div>
                        <select
                          onChange={(e) => filterOnTypeTransaction(e)}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.all')}</option>
                          <option value="0">{t('transactions.filters.payments')}</option>
                          <option value="1">{t('transactions.filters.reversal')}</option>
                        </select>
                      </div>

                      {/* Opérateur */}
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.operator')}
                          </h6>
                        </div>
                        <select
                          onChange={(e) => filterOnOperator(e)}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.allOperators')}</option>
                          {optionListeOperateur}
                        </select>
                      </div>

                      {/* Prestataire (Admin seulement) */}
                      {localStorage.getItem("role") === "ROLE_ADMIN" && (
                        <div style={{ marginBottom: "8px" }}>
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <h6
                              style={{
                                fontSize: "14px",
                                fontWeight: "800",
                                color: "#374151",
                                margin: 0,
                              }}
                            >
                              {t('transactions.filters.provider')}
                            </h6>
                          </div>

                          <select
                            onChange={handleRecupereIdPrestataireAndFilter}
                            style={{
                              width: "100%",
                              padding: "12px 8px",
                              border: "1px solid #d1d5db",
                              borderRadius: "6px",
                              fontSize: "14px",
                              backgroundColor: "#fafafa",
                            }}
                          >
                            <option value="">{t('transactions.filters.allProviders')}</option>
                            {optionPrestataire}
                          </select>
                        </div>
                      )}

                      <div className="d-flex gap-3">
                        {/* Service */}
                        <div style={{ marginBottom: "8px" }}>
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <h6
                              style={{
                                fontSize: "14px",
                                fontWeight: "800",
                                color: "#374151",
                                margin: 0,
                              }}
                            >
                              {t('transactions.filters.service')}
                            </h6>
                          </div>

                          <select
                            onChange={filterOnService}
                            style={{
                              width: "100%",
                              padding: "12px 8px",
                              border: "1px solid #d1d5db",
                              borderRadius: "6px",
                              fontSize: "14px",
                              backgroundColor: "#fafafa",
                            }}
                          >
                            <option value="">{t('transactions.filters.allServices')}</option>
                            {optionListeService}
                          </select>
                        </div>

                        {/* Statut */}
                        <div style={{ marginBottom: "8px" }}>
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <h6
                              style={{
                                fontSize: "14px",
                                fontWeight: "800",
                                color: "#374151",
                                margin: 0,
                              }}
                            >
                              {t('transactions.filters.status')}
                            </h6>
                          </div>

                          <select
                            onChange={filterOnStatut}
                            style={{
                              width: "100%",
                              padding: "12px 8px",
                              border: "1px solid #d1d5db",
                              borderRadius: "6px",
                              fontSize: "14px",
                              backgroundColor: "#fafafa",
                            }}
                          >
                            <option value="">{t('transactions.filters.allStatuses')}</option>
                            {optionStatut}
                          </select>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered celled padded">
                  <thead>
                    <tr>
                      <th
                        className="single line"
                        style={{ backgroundColor: "#F0F0F0" }}
                      >
                        {t('transactions.table.service')}
                      </th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>
                        {t('transactions.table.refTransaction')}
                      </th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.operator')}</th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.phone')}</th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.amount')}</th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.commission')}</th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.date')}</th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.status')}</th>
                    </tr>
                  </thead>
                  <tbody>{rowListeTransaction}</tbody>
                  <tfoot>
                    <tr>
                      <th colSpan="7">
                        <div className="d-flex justify-content-center">
                          <Paginate
                            pageActive={pageActive}
                            handlePageChange={handlePageChange}
                            nbreElementParPage={totalElementByPage}
                            nbreTotalElmentPage={totalElement}
                          />
                        </div>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              {loading && (
                <div className="d-flex justify-content-center">
                  <Oval
                    width={30}
                    height={30}
                    color="#344b7b"
                    visible={loading}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        {/* MONTANT PAR SERVICE */}
        {currentComponent === "AUTRES" && (
          <div>
            {/* Stats cards modernes */}
            <div className="row mb-3 gap-2">
              <div
                style={{
                  backgroundColor: "#f0f9ff",
                  borderRadius: "8px",
                  padding: "14px",
                  border: "1px solid #e0f2fe",
                  minWidth: "280px",
                }}
                className="col"
              >
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "38px",
                      height: "38px",
                      borderRadius: "100px",
                      backgroundColor: "#e3f2fd",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                    }}
                  >
                    <i
                      className="fas fa-hashtag"
                      style={{ color: "#2196f3", fontSize: "14px" }}
                    ></i>
                  </div>
                  <div>
                    <h5
                      style={{
                        margin: 0,
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#333",
                      }}
                    >
                      {t('transactions.cards.totalTransactions')}
                    </h5>
                  </div>
                </div>
                <div className="mt-2">
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12px",
                      color: "#666",
                      fontWeight: "500",
                    }}
                  >
                    {t('transactions.cards.total')}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#2196f3",
                    }}
                  >
                    {nombreTransactionTotal}
                  </p>
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "#ecfdf5",
                  borderRadius: "8px",
                  padding: "14px",
                  border: "1px solid #d1fae5",
                  minWidth: "280px",
                }}
                className="col"
              >
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "38px",
                      height: "38px",
                      borderRadius: "100px",
                      backgroundColor: "#e8f5e8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                    }}
                  >
                    <i
                      className="fas fa-coins"
                      style={{ color: "#4caf50", fontSize: "14px" }}
                    ></i>
                  </div>
                  <div>
                    <h5
                      style={{
                        margin: 0,
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#333",
                      }}
                    >
                      {t('transactions.cards.totalAmount')}
                    </h5>
                  </div>
                </div>
                <div className="mt-2">
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12px",
                      color: "#666",
                      fontWeight: "500",
                    }}
                  >
                    {t('transactions.cards.amount')}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#4caf50",
                    }}
                  >
                    {convertNumber(montantTransactionTotal)} FCFA
                  </p>
                </div>
              </div>
            </div>

            <div className="">
              {/* Header avec bouton Filter */}
              <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                <div>
                  <h4
                    style={{
                      margin: 0,
                      fontSize: "18px",
                      fontWeight: "800",
                      color: "#000",
                    }}
                  >
                    {t('transactions.tabs.amountByService')}
                  </h4>
                </div>

                <div className="d-flex gap-3" style={{ position: "relative" }}>
                  <button
                    onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                    style={{
                      backgroundColor: "black",
                      borderRadius: "8px",
                      padding: "8px 16px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "white",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i
                      className="fas fa-filter"
                      style={{ fontSize: "12px" }}
                    ></i>
                    Filter
                  </button>

                  {/* Dropdown de filtres */}
                  {showFilterDropdown && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: "0",
                        marginTop: "8px",
                        backgroundColor: "white",
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        padding: "14px",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        minWidth: "350px",
                        maxHeight: "600px",
                        // overflowY: "auto",
                      }}
                    >
                      {/* Date range */}
                      <div style={{ marginBottom: "8px" }}>
                        <h6
                          className="mb-1"
                          style={{
                            fontSize: "14px",
                            fontWeight: "800",
                            color: "#374151",
                            margin: 0,
                          }}
                        >
                          {t('transactions.filters.period')}
                        </h6>
                        <DateFilter filterElement={filterOnDate} />
                      </div>

                      {/* Opérateur */}
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.operator')}
                          </h6>
                        </div>
                        <select
                          onChange={(e) => filterOnOperator(e)}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.allOperators')}</option>
                          {optionListeOperateur}
                        </select>
                      </div>

                      {/* Service */}
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.service')}
                          </h6>
                        </div>
                        <select
                          onChange={filterOnService}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.allServices')}</option>
                          {optionListeService}
                        </select>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered celled padded">
                  <thead>
                    <tr>
                      <th className="single line">{t('transactions.table.service')}</th>
                      <th>{t('transactions.table.transactionCount')}</th>
                      <th>{t('transactions.table.amount')}</th>
                      <th>{t('transactions.table.payment')}</th>
                      <th>{t('transactions.table.transfer')}</th>
                      <th>{t('transactions.table.commission')}</th>
                    </tr>
                  </thead>
                  <tbody>{rowListeMontantTransaction}</tbody>
                  <tfoot>
                    <tr>
                      <th colSpan="7">
                        <div className="d-flex justify-content-center">
                          <Paginate
                            pageActive={pageActive}
                            handlePageChange={handlePageChange2}
                            nbreElementParPage={totalElementByPage2}
                            nbreTotalElmentPage={totalElement2}
                          />
                        </div>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              {loading && (
                <div className="d-flex justify-content-center">
                  <Oval
                    width={30}
                    height={30}
                    color="#344b7b"
                    visible={loading}
                  />
                </div>
              )}
            </div>
          </div>
        )}

        {/* PAIEMENTS EFFECTUÉS */}
        {currentComponent === "PAIEMENTS_EFFECTUES" && (
          <div className="">
            {/* TABLEAU RECAP PAIEMENT PRESTATAIRE - Résumé des paiements et reversements */}
            {getDisplayMode() === "TABLEAU" && localStorage.getItem("role") !== "ROLE_ADMIN" && (
              <div className="table-responsive">
                <table className="table table-bordered celled padded">
                  <thead>
                    <tr>
                      <th style={{ backgroundColor: "#F0F0F0" }}>
                        {t('transactions.summary.totalPayment')}
                      </th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>
                        {t('transactions.summary.autoReversals')}
                      </th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>
                        {t('transactions.summary.manualReversals')}
                      </th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>
                        {t('transactions.summary.skanpayCommission')}
                      </th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.summary.balance')}</th>
                    </tr>
                  </thead>
                  <tbody>{rowListeReversementSolde}</tbody>
                </table>
                {loadingSolde && (
                  <div className="d-flex justify-content-center">
                    <Oval
                      width={30}
                      height={30}
                      color="#344b7b"
                      visible={loadingSolde}
                    />
                  </div>
                )}
              </div>
            )}

            {getDisplayMode() === "CARD" && localStorage.getItem("role") !== "ROLE_ADMIN" && (
              <div style={{ width: "100%" }} className="d-flex flex-wrap gap-2">
                <div className="stats-card-wrapper">
                  <div
                    style={{
                      backgroundColor: "#fff4e6",
                      borderRadius: "8px",
                      padding: "10px",
                      border: "1px solid #fed7aa",
                    }}
                    className="card"
                  >
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#fed7aa",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ color: "#ea580c", fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "8px",
                          }}
                        >
                          {t('transactions.summary.totalPayment')}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#ea580c",
                          }}
                        >
                          {infoStats && infoStats.montantPaiement
                            ? convertNumber(infoStats.montantPaiement)
                            : "0"}
                          FCFA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="stats-card-wrapper">
                  <div
                    style={{
                      backgroundColor: "#f0f9ff",
                      borderRadius: "8px",
                      padding: "10px",
                      border: "1px solid #7dd3fc",
                    }}
                    className="card"
                  >
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#7dd3fc",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ color: "#0284c7", fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "8px",
                          }}
                        >
                          {t('transactions.summary.autoReversals')}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#0284c7",
                          }}
                        >
                          {infoStats && infoStats.montantReversementAutomatiqueGlobal
                            ? convertNumber(infoStats.montantReversementAutomatiqueGlobal)
                            : "0"}
                          FCFA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="stats-card-wrapper">
                  <div
                    style={{
                      backgroundColor: "#faf5ff",
                      borderRadius: "8px",
                      padding: "10px",
                      border: "1px solid #d8b4fe",
                    }}
                    className="card"
                  >
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#d8b4fe",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ color: "#7e22ce", fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "8px",
                          }}
                        >
                          {t('transactions.summary.manualReversals')}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#7e22ce",
                          }}
                        >
                          {infoStats && infoStats.montantReversementManuelGlobal
                            ? convertNumber(infoStats.montantReversementManuelGlobal)
                            : "0"}
                          FCFA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="stats-card-wrapper">
                  <div
                    style={{
                      backgroundColor: "#fff4e6",
                      borderRadius: "8px",
                      padding: "10px",
                      border: "1px solid #fed7aa",
                    }}
                    className="card"
                  >
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#fed7aa",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ color: "#ea580c", fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "8px",
                          }}
                        >
                          {t('transactions.summary.skanpayCommission')}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#ea580c",
                          }}
                        >
                          {infoStats && infoStats.commissionGlobal
                            ? convertNumber(infoStats.commissionGlobal)
                            : "0"}
                          FCFA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="stats-card-wrapper">
                  <div
                    style={{
                      backgroundColor: "#ecfdf5",
                      borderRadius: "8px",
                      padding: "10px",
                      border: "1px solid #10b981",
                    }}
                    className="card"
                  >
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#10b981",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ color: "#fff", fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "8px",
                          }}
                        >
                          {t('transactions.summary.balance')}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#047857",
                          }}
                        >
                          {montantAreverser ? convertNumber(montantAreverser) : "0"}
                          FCFA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Header avec boutons Sort et Filter */}
            <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
              <div>
                <h4
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    fontWeight: "800",
                    color: "#000",
                  }}
                >
                  {t('transactions.history.paymentsCompleted')}
                </h4>
              </div>

              <div className="d-flex gap-3" style={{ position: "relative" }}>
                <button
                  onClick={() => exporterTransactions()}
                  style={{
                    backgroundColor: "#f9ba14",
                    borderRadius: "8px",
                    border: "none",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "black",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {loadingDownload ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {t('transactions.actions.loading')}
                    </>
                  ) : (
                    <>
                      <i
                        className="fas fa-file-export"
                        style={{ fontSize: "12px" }}
                      ></i>
                      {t('transactions.actions.export')}
                    </>
                  )}
                </button>
                <button
                  onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                  style={{
                    backgroundColor: "black",
                    borderRadius: "8px",
                    border: "none",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "white",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fas fa-filter" style={{ fontSize: "12px" }}></i>
                  Filter
                </button>

                {/* Dropdown de filtres */}
                {showFilterDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: "0",
                      marginTop: "8px",
                      backgroundColor: "white",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      padding: "14px",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                      zIndex: 1000,
                      minWidth: "350px",
                      maxHeight: "600px",
                      // overflowY: "auto",
                    }}
                  >
                    {/* Recherche par mot-clé */}
                    <div style={{ marginBottom: "8px" }}>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6
                          style={{
                            fontSize: "14px",
                            fontWeight: "800",
                            color: "#374151",
                            margin: 0,
                          }}
                        >
                          {t('transactions.filters.search')}
                        </h6>
                      </div>

                      <div style={{ position: "relative" }}>
                        <input
                          onChange={(e) => handleSearchTransaction(e)}
                          type="text"
                          placeholder="Search..."
                          style={{
                            width: "100%",
                            padding: "12px 8px 12px 45px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        />
                        <i
                          className="fas fa-search"
                          style={{
                            position: "absolute",
                            left: "16px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#9ca3af",
                            fontSize: "14px",
                          }}
                        ></i>
                      </div>
                    </div>

                    {/* Date range */}
                    <div style={{ marginBottom: "8px" }}>
                      <h6
                        className="mb-1"
                        style={{
                          fontSize: "14px",
                          fontWeight: "800",
                          color: "#374151",
                          margin: 0,
                        }}
                      >
                        {t('transactions.filters.period')}
                      </h6>
                      <DateFilter filterElement={filterOnDate} />
                    </div>

                    {/* Opérateur */}
                    <div style={{ marginBottom: "8px" }}>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6
                          style={{
                            fontSize: "14px",
                            fontWeight: "800",
                            color: "#374151",
                            margin: 0,
                          }}
                        >
                          {t('transactions.filters.operator')}
                        </h6>
                      </div>
                      <select
                        onChange={(e) => filterOnOperator(e)}
                        style={{
                          width: "100%",
                          padding: "12px 8px",
                          border: "1px solid #d1d5db",
                          borderRadius: "6px",
                          fontSize: "14px",
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <option value="">{t('transactions.filters.allOperators')}</option>
                        {optionListeOperateur}
                      </select>
                    </div>

                    {/* Prestataire (Admin seulement) */}
                    {localStorage.getItem("role") === "ROLE_ADMIN" && (
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.provider')}
                          </h6>
                        </div>

                        <select
                          onChange={handleRecupereIdPrestataireAndFilter}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.allProviders')}</option>
                          {optionPrestataire}
                        </select>
                      </div>
                    )}

                    <div className="d-flex gap-3">
                      {/* Service */}
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.service')}
                          </h6>
                        </div>

                        <select
                          onChange={filterOnService}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.allServices')}</option>
                          {optionListeService}
                        </select>
                      </div>

                      {/* Statut */}
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.status')}
                          </h6>
                        </div>

                        <select
                          onChange={filterOnStatut}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.allStatuses')}</option>
                          {optionStatut}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="table-responsive mt-3">
              <table className="table table-bordered celled padded">
                <thead>
                  <tr>
                    <th
                      className="single line"
                      style={{ backgroundColor: "#F0F0F0" }}
                    >
                      {t('transactions.table.service')}
                    </th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>
                      {t('transactions.table.refTransaction')}
                    </th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.operator')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.phone')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.amount')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.commission')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.date')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.status')}</th>
                  </tr>
                </thead>
                <tbody>{rowListeTransaction}</tbody>
                <tfoot>
                  <tr>
                    <th colSpan="7">
                      <div className="d-flex justify-content-center">
                        <Paginate
                          pageActive={pageActive}
                          handlePageChange={handlePageChange}
                          nbreElementParPage={totalElementByPage}
                          nbreTotalElmentPage={totalElement}
                        />
                      </div>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
            {loading && (
              <div className="d-flex justify-content-center">
                <Oval
                  width={30}
                  height={30}
                  color="#344b7b"
                  visible={loading}
                />
              </div>
            )}
          </div>
        )}

        {/* TRANSFERTS */}
        {currentComponent === "TRANSFERT" && (
          <div className="">
            {/* TABLEAU RECAP PAIEMENT PRESTATAIRE - Résumé des paiements et reversements */}
            {getDisplayMode() === "TABLEAU" && localStorage.getItem("role") !== "ROLE_ADMIN" && (
              <div className="table-responsive">
                <table className="table table-bordered celled padded">
                  <thead>
                    <tr>
                      <th style={{ backgroundColor: "#F0F0F0" }}>
                        {t('transactions.summary.totalPayment')}
                      </th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>
                        {t('transactions.summary.autoReversals')}
                      </th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>
                        {t('transactions.summary.manualReversals')}
                      </th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>
                        {t('transactions.summary.skanpayCommission')}
                      </th>
                      <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.summary.balance')}</th>
                    </tr>
                  </thead>
                  <tbody>{rowListeReversementSolde}</tbody>
                </table>
                {loadingSolde && (
                  <div className="d-flex justify-content-center">
                    <Oval
                      width={30}
                      height={30}
                      color="#344b7b"
                      visible={loadingSolde}
                    />
                  </div>
                )}
              </div>
            )}

            {getDisplayMode() === "CARD" && localStorage.getItem("role") !== "ROLE_ADMIN" && (
              <div style={{ width: "100%" }} className="d-flex flex-wrap gap-2">
                <div className="stats-card-wrapper">
                  <div
                    style={{
                      backgroundColor: "#fff4e6",
                      borderRadius: "8px",
                      padding: "10px",
                      border: "1px solid #fed7aa",
                    }}
                    className="card"
                  >
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#fed7aa",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ color: "#ea580c", fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "8px",
                          }}
                        >
                          {t('transactions.summary.totalPayment')}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#ea580c",
                          }}
                        >
                          {infoStats && infoStats.montantPaiement
                            ? convertNumber(infoStats.montantPaiement)
                            : "0"}
                          FCFA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="stats-card-wrapper">
                  <div
                    style={{
                      backgroundColor: "#f0f9ff",
                      borderRadius: "8px",
                      padding: "10px",
                      border: "1px solid #7dd3fc",
                    }}
                    className="card"
                  >
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#7dd3fc",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ color: "#0284c7", fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "8px",
                          }}
                        >
                          {t('transactions.summary.autoReversals')}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#0284c7",
                          }}
                        >
                          {infoStats && infoStats.montantReversementAutomatiqueGlobal
                            ? convertNumber(infoStats.montantReversementAutomatiqueGlobal)
                            : "0"}
                          FCFA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="stats-card-wrapper">
                  <div
                    style={{
                      backgroundColor: "#faf5ff",
                      borderRadius: "8px",
                      padding: "10px",
                      border: "1px solid #d8b4fe",
                    }}
                    className="card"
                  >
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#d8b4fe",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ color: "#7e22ce", fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "8px",
                          }}
                        >
                          {t('transactions.summary.manualReversals')}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#7e22ce",
                          }}
                        >
                          {infoStats && infoStats.montantReversementManuelGlobal
                            ? convertNumber(infoStats.montantReversementManuelGlobal)
                            : "0"}
                          FCFA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="stats-card-wrapper">
                  <div
                    style={{
                      backgroundColor: "#fff4e6",
                      borderRadius: "8px",
                      padding: "10px",
                      border: "1px solid #fed7aa",
                    }}
                    className="card"
                  >
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#fed7aa",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ color: "#ea580c", fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "8px",
                          }}
                        >
                          {t('transactions.summary.skanpayCommission')}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#ea580c",
                          }}
                        >
                          {infoStats && infoStats.commissionGlobal
                            ? convertNumber(infoStats.commissionGlobal)
                            : "0"}
                          FCFA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="stats-card-wrapper">
                  <div
                    style={{
                      backgroundColor: "#ecfdf5",
                      borderRadius: "8px",
                      padding: "10px",
                      border: "1px solid #10b981",
                    }}
                    className="card"
                  >
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100px",
                          backgroundColor: "#10b981",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "10px",
                        }}
                      >
                        <i
                          className="fas fa-dollar-sign"
                          style={{ color: "#fff", fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "8px",
                          }}
                        >
                          {t('transactions.summary.balance')}
                        </h5>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "18px",
                            fontWeight: "700",
                            color: "#047857",
                          }}
                        >
                          {montantAreverser ? convertNumber(montantAreverser) : "0"}
                          FCFA
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Header avec boutons Sort et Filter */}
            <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
              <div>
                <h4
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    fontWeight: "800",
                    color: "#000",
                  }}
                >
                  {t('transactions.history.transfers')}
                </h4>
              </div>

              <div className="d-flex gap-3" style={{ position: "relative" }}>
                <button
                  onClick={() => exporterTransactions()}
                  style={{
                    backgroundColor: "#f9ba14",
                    borderRadius: "8px",
                    border: "none",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "black",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {loadingDownload ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {t('transactions.actions.loading')}
                    </>
                  ) : (
                    <>
                      <i
                        className="fas fa-file-export"
                        style={{ fontSize: "12px" }}
                      ></i>
                      {t('transactions.actions.export')}
                    </>
                  )}
                </button>
                <button
                  onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                  style={{
                    backgroundColor: "black",
                    borderRadius: "8px",
                    border: "none",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "white",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fas fa-filter" style={{ fontSize: "12px" }}></i>
                  Filter
                </button>

                {/* Dropdown de filtres */}
                {showFilterDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: "0",
                      marginTop: "8px",
                      backgroundColor: "white",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      padding: "14px",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                      zIndex: 1000,
                      minWidth: "350px",
                      maxHeight: "600px",
                      // overflowY: "auto",
                    }}
                  >
                    {/* Recherche par mot-clé */}
                    <div style={{ marginBottom: "8px" }}>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6
                          style={{
                            fontSize: "14px",
                            fontWeight: "800",
                            color: "#374151",
                            margin: 0,
                          }}
                        >
                          {t('transactions.filters.search')}
                        </h6>
                      </div>

                      <div style={{ position: "relative" }}>
                        <input
                          onChange={(e) => handleSearchTransaction(e)}
                          type="text"
                          placeholder="Search..."
                          style={{
                            width: "100%",
                            padding: "12px 8px 12px 45px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        />
                        <i
                          className="fas fa-search"
                          style={{
                            position: "absolute",
                            left: "16px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#9ca3af",
                            fontSize: "14px",
                          }}
                        ></i>
                      </div>
                    </div>

                    {/* Date range */}
                    <div style={{ marginBottom: "8px" }}>
                      <h6
                        className="mb-1"
                        style={{
                          fontSize: "14px",
                          fontWeight: "800",
                          color: "#374151",
                          margin: 0,
                        }}
                      >
                        {t('transactions.filters.period')}
                      </h6>
                      <DateFilter filterElement={filterOnDate} />
                    </div>

                    {/* Opérateur */}
                    <div style={{ marginBottom: "8px" }}>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <h6
                          style={{
                            fontSize: "14px",
                            fontWeight: "800",
                            color: "#374151",
                            margin: 0,
                          }}
                        >
                          {t('transactions.filters.operator')}
                        </h6>
                      </div>
                      <select
                        onChange={(e) => filterOnOperator(e)}
                        style={{
                          width: "100%",
                          padding: "12px 8px",
                          border: "1px solid #d1d5db",
                          borderRadius: "6px",
                          fontSize: "14px",
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <option value="">{t('transactions.filters.allOperators')}</option>
                        {optionListeOperateur}
                      </select>
                    </div>

                    {/* Prestataire (Admin seulement) */}
                    {localStorage.getItem("role") === "ROLE_ADMIN" && (
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.provider')}
                          </h6>
                        </div>

                        <select
                          onChange={handleRecupereIdPrestataireAndFilter}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.allProviders')}</option>
                          {optionPrestataire}
                        </select>
                      </div>
                    )}

                    <div className="d-flex gap-3">
                      {/* Service */}
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.service')}
                          </h6>
                        </div>

                        <select
                          onChange={filterOnService}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.allServices')}</option>
                          {optionListeService}
                        </select>
                      </div>

                      {/* Statut */}
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.status')}
                          </h6>
                        </div>

                        <select
                          onChange={filterOnStatut}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.allStatuses')}</option>
                          {optionStatut}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th
                      className="single line"
                      style={{ backgroundColor: "#F0F0F0" }}
                    >
                      {t('transactions.table.service')}
                    </th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>
                      {t('transactions.table.refTransaction')}
                    </th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.operator')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.phone')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.amount')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.commission')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.date')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.status')}</th>
                  </tr>
                </thead>
                <tbody>{rowListeTransaction}</tbody>
                <tfoot>
                  <tr>
                    <th colSpan="7">
                      <div className="d-flex justify-content-center">
                        <Paginate
                          pageActive={pageActive}
                          handlePageChange={handlePageChange}
                          nbreElementParPage={totalElementByPage}
                          nbreTotalElmentPage={totalElement}
                        />
                      </div>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
            {loading && (
              <div className="d-flex justify-content-center">
                <Oval
                  width={30}
                  height={30}
                  color="#344b7b"
                  visible={loading}
                />
              </div>
            )}
          </div>
        )}

        {/* PAIEMENT PAR OPERATEUR */}
        {currentComponent === "PAIEMENT_OPERATEUR" && (
          <div className="">
            {/* Header avec boutons Sort et Filter */}
            <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
              <div>
                <h4
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    fontWeight: "800",
                    color: "#000",
                  }}
                >
                  {t('transactions.history.paymentsByOperator')}
                </h4>
                {filterParametresOperateur.dateDebut && (
                  <p className="mt-1" style={{ color: "#737373" }}>
                    Du {new Date(filterParametresOperateur.dateDebut).toLocaleDateString("FR-fr")} au{" "}
                    {new Date(filterParametresOperateur.dateFin).toLocaleDateString("FR-fr")}
                  </p>
                )}
                {!filterParametresOperateur.dateDebut && (
                  <p className="mt-1" style={{ color: "#737373" }}>
                    Du {new Date().toLocaleDateString("FR-fr")} au{" "}
                    {new Date().toLocaleDateString("FR-fr")}
                  </p>
                )}
              </div>

              {localStorage.getItem("role") !== "ROLE_ADMIN" && <DateFilter filterElement={filterOnDate} />}

              {localStorage.getItem("role") === "ROLE_ADMIN" && <div className="d-flex gap-3" style={{ position: "relative" }}>
                <button
                  onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                  style={{
                    backgroundColor: "black",
                    borderRadius: "8px",
                    border: "none",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "white",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fas fa-filter" style={{ fontSize: "12px" }}></i>
                  {t('transactions.actions.filter')}
                </button>

                {/* Dropdown de filtres */}
                {showFilterDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: "0",
                      marginTop: "8px",
                      backgroundColor: "white",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      padding: "14px",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                      zIndex: 1000,
                      minWidth: "350px",
                      maxHeight: "600px",
                      // overflowY: "auto",
                    }}
                  >
                    {/* Date range */}
                    <div style={{ marginBottom: "8px" }}>
                      <h6
                        className="mb-1"
                        style={{
                          fontSize: "14px",
                          fontWeight: "800",
                          color: "#374151",
                          margin: 0,
                        }}
                      >
                        {t('transactions.filters.period')}
                      </h6>
                      <DateFilter filterElement={filterOnDate} />
                    </div>

                    {/* Prestataire (Admin seulement) */}
                    {localStorage.getItem("role") === "ROLE_ADMIN" && (
                      <div style={{ marginBottom: "8px" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <h6
                            style={{
                              fontSize: "14px",
                              fontWeight: "800",
                              color: "#374151",
                              margin: 0,
                            }}
                          >
                            {t('transactions.filters.provider')}
                          </h6>
                        </div>

                        <select
                          onChange={handleRecupereIdPrestataireAndFilter}
                          style={{
                            width: "100%",
                            padding: "12px 8px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <option value="">{t('transactions.filters.allProviders')}</option>
                          {optionPrestataire}
                        </select>
                      </div>
                    )}

                    {localStorage.getItem("role") === "ROLE_ADMIN" && (
                      <div className="">
                        {/* Service */}
                        <div style={{ marginBottom: "8px" }}>
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <h6
                              style={{
                                fontSize: "14px",
                                fontWeight: "800",
                                color: "#374151",
                                margin: 0,
                              }}
                            >
                              {t('transactions.filters.service')}
                            </h6>
                          </div>

                          <select
                            onChange={filterOnService}
                            style={{
                              width: "100%",
                              padding: "12px 8px",
                              border: "1px solid #d1d5db",
                              borderRadius: "6px",
                              fontSize: "14px",
                              backgroundColor: "#fafafa",
                            }}
                          >
                            <option value="">{t('transactions.filters.allServices')}</option>
                            {optionListeService}
                          </select>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>}
            </div>
            <div className="table-responsive mt-4">
              <table className="table table-bordered celled padded">
                <thead>
                  <tr>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.operator')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>
                      {t('transactions.table.transactionsCount')}
                    </th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.amount')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.commission')}</th>
                    <th style={{ backgroundColor: "#F0F0F0" }}>{t('transactions.table.transfer')}</th>
                  </tr>
                </thead>
                <tbody>{rowListePaiementParOperateur}</tbody>
              </table>
            </div>
            {loading && (
              <div className="d-flex justify-content-center">
                <Oval
                  width={30}
                  height={30}
                  color="#344b7b"
                  visible={loading}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </Layout>
  );
}

export default Transaction;
